import APP_ENTRIES from '@/consts/appEntries';
import REFETCH_DATA_TYPES from '@/consts/refetchDataTypes';
import eventMessagesService from '@/services/events/eventMessagesService';
import {consumeExternalLinkOpened} from '@/services/events/externalLinkReturnTracker';
import {selectActiveModule} from '@/state/selectors/app';
import {getState} from '@/state/store';

import useOnReturnToTab from './useOnReturnToTab';

/**
 * When the user returns to the tab/iframe after having opened an external link,
 * asks the parent app to refetch data by sending `UWM_MODULE_REFETCH_DATA_REQUEST`
 * with a `dataType` derived from the current active entry point.
 *
 * The parent is expected to respond with `UWM_REFRESH_DATA` carrying the refreshed payload.
 *
 * @warning This hook always requests a refetch for the active entry point at the time
 * the user returns. If different refetch behaviour is needed (e.g. refetching multiple
 * data types or using a custom trigger), implement a dedicated hook instead of extending
 * this one.
 */
const useExternalLinkReturnRefetch = () => {
    useOnReturnToTab(() => {
        if (!consumeExternalLinkOpened()) return;
        const entry = selectActiveModule(getState());
        if (!entry) return;
        const dataType = entry === APP_ENTRIES.REWARDS ? REFETCH_DATA_TYPES.REWARDS : REFETCH_DATA_TYPES.BADGES;
        eventMessagesService.sendRefetchDataRequest(dataType);
    });
};

export default useExternalLinkReturnRefetch;
